export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const SIGNOUT = "SIGNOUT";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUT_FAILURE = "SIGNOUT_FAILURE";

export const SIGNIN = "SIGNIN";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAILURE = "SIGNIN_FAILURE";

export const LOADER_TRUE = "LOADER_TRUE";
export const LOADER_FALSE = "LOADER_FALSE";

export const VERIFICATION_CODE = "VERIFICATION_CODE";
export const VERIFICATION_CODE_SUCCESS = " VERIFICATION_CODE_SUCCESS";
export const VERIFICATION_CODE_FAILURE = " VERIFICATION_CODE_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = " RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = " RESET_PASSWORD_FAILURE";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = " FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = " FORGOT_PASSWORD_FAILURE";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CLOSE_ALL_MODAL = "CLOSE_ALL_MODAL";

export const CREATE_EVENT_REQ = "CREATE_EVENT_REQ";
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS";
export const CREATE_EVENT_ERROR = "CREATE_EVENT_ERROR";

export const CREATE_USER_CLASS_REQ = "CREATE_USER_CLASS_REQ";
export const CREATE_USER_CLASS_SUCCESS = "CREATE_USER_CLASS_SUCCESS";
export const CREATE_USER_CLASS_ERROR = "CREATE_USER_CLASS_ERROR";

export const CREATE_EVENT_QUESTION_REQ = "CREATE_EVENT_QUESTION_REQ";
export const CREATE_EVENT_QUESTION_SUCCESS = "CREATE_EVENT_QUESTION_SUCCESS";
export const CREATE_EVENT_QUESTION_ERROR = "CREATE_EVENT_QUESTION_ERROR";

export const CREATE_DRESSAGE_REQ = "CREATE_DRESSAGE_REQ";
export const CREATE_DRESSAGE_SUCCESS = "CREATE_DRESSAGE_SUCCESS";
export const CREATE_DRESSAGE_ERROR = "CREATE_DRESSAGE_ERROR";

export const CREATE_EVENT_CLASS_REQ = "CREATE_EVENT_CLASS_REQ";
export const CREATE_EVENT_CLASS_SUCCESS = "CREATE_EVENT_CLASS_SUCCESS";
export const CREATE_EVENT_CLASS_ERROR = "CREATE_EVENT_CLASS_ERROR";

export const CREATE_SHOW_JUMPING_REQ = "CREATE_SHOW_JUMPING_REQ";
export const CREATE_SHOW_JUMPING_SUCCESS = "CREATE_SHOW_JUMPING_SUCCESS";
export const CREATE_SHOW_JUMPING_ERROR = "CREATE_SHOW_JUMPING_ERROR";

export const CREATE_CROSS_COUNTRY_REQ = "CREATE_CROSS_COUNTRY_REQ";
export const CREATE_CROSS_COUNTRY_SUCCESS = "CREATE_CROSS_COUNTRY_SUCCESS";
export const CREATE_CROSS_COUNTRY_ERROR = "CREATE_CROSS_COUNTRY_ERROR";

export const CREATE_CROSS_COUNTRY_FENCE_REQ = "CREATE_CROSS_COUNTRY_FENCE_REQ";
export const CREATE_CROSS_COUNTRY_FENCE_SUCCESS =
  "CREATE_CROSS_COUNTRY_FENCE_SUCCESS";
export const CREATE_CROSS_COUNTRY_FENCE_ERROR =
  "CREATE_CROSS_COUNTRY_FENCE_ERROR";

export const GET_CLASS_REQ = "GET_CLASS_REQ";
export const GET_CLASS_SUCCESS = "GET_CLASS_SUCCESS";
export const GET_CLASS_ERROR = "GET_CLASS_ERROR";

export const GET_TEST_REQ = "GET_TEST_REQ";
export const GET_TEST_SUCCESS = "GET_TEST_SUCCESS";
export const GET_TEST_ERROR = "GET_TEST_ERROR";

export const SEARCH_JUDGE_REQ = "SEARCH_JUDGE_REQ";
export const SEARCH_JUDGE_SUCCESS = "SEARCH_JUDGE_SUCCESS";
export const SEARCH_JUDGE_ERROR = "SEARCH_JUDGE_ERROR";

export const GET_EVENT_CLASS_REQ = "GET_EVENT_CLASS_REQ";
export const GET_EVENT_CLASS_SUCCESS = "GET_EVENT_CLASS_SUCCESS";
export const GET_EVENT_CLASS_ERROR = "GET_EVENT_CLASS_ERROR";

export const GET_EVENT_QUESTION_REQ = "GET_EVENT_QUESTION_REQ";
export const GET_EVENT_QUESTION_SUCCESS = "GET_EVENT_QUESTION_SUCCESS";
export const GET_EVENT_QUESTION_ERROR = "GET_EVENT_QUESTION_ERROR";

export const GET_EVENT_CLASS_DETAILS_REQ = "GET_EVENT_CLASS_DETAILS_REQ";
export const GET_EVENT_CLASS_DETAILS_SUCCESS =
  "GET_EVENT_CLASS_DETAILS_SUCCESS";
export const GET_EVENT_CLASS_DETAILS_ERROR = "GET_EVENT_CLASS_DETAILS_ERROR";

export const GET_CROSS_COUNTRY_REQ = "GET_CROSS_COUNTRY_REQ";
export const GET_CROSS_COUNTRY_SUCCESS = "GET_CROSS_COUNTRY_SUCCESS";
export const GET_CROSS_COUNTRY_ERROR = "GET_CROSS_COUNTRY_ERROR";

export const DELETE_DRESSAGE_REQ = "DELETE_DRESSAGE_REQ";
export const DELETE_DRESSAGE_SUCCESS = "DELETE_DRESSAGE_SUCCES";
export const DELETE_DRESSAGE_ERROR = "DELETE_DRESSAGE_ERROR";

export const DELETE_EVENT_CLASS_REQ = "DELETE_EVENT_CLASS_REQ";
export const DELETE_EVENT_CLASS_SUCCESS = "DELETE_EVENT_CLASS_SUCCES";
export const DELETE_EVENT_CLASS_ERROR = "DELETE_EVENT_CLASS_ERROR";

export const DELETE_EVENT_QUESTION_REQ = "DELETE_EVENT_QUESTION_REQ";
export const DELETE_EVENT_QUESTION_SUCCESS = "DELETE_EVENT_QUESTION_SUCCES";
export const DELETE_EVENT_QUESTION_ERROR = "DELETE_EVENT_QUESTION_ERROR";

export const GET_DRESSAGE_REQUEST = "GET_DRESSAGE_REQUEST";
export const GET_DRESSAGE_SUCCESS = "GET_DRESSAGE_SUCCESS";
export const GET_DRESSAGE_ERROR = "GET_DRESSAGE_ERROR";

export const GET_SHOW_JUMPING_REQ = "GET_SHOW_JUMPING_REQ";
export const GET_SHOW_JUMPING_SUCCESS = "GET_SHOW_JUMPING_SUCCESS";
export const GET_SHOW_JUMPING_ERROR = "GET_SHOW_JUMPING_ERROR";

export const DELETE_SHOW_JUMPING_REQ = "DELETE_SHOW_JUMPING_REQ";
export const DELETE_SHOW_JUMPING_SUCCESS = "DELETE_SHOW_JUMPING_SUCCESS";
export const DELETE_SHOW_JUMPING_ERROR = "DELETE_SHOW_JUMPING_ERROR";

export const DELETE_CROSS_COUNTRY_REQ = "DELETE_CROSS_COUNTRY_REQ";
export const DELETE_CROSS_COUNTRY_SUCCESS = "DELETE_CROSS_COUNTRY_SUCCESS";
export const DELETE_CROSS_COUNTRY_ERROR = "DELETE_CROSS_COUNTRY_ERROR";

export const CONFIRM_EVENT_REQ = "CONFIRM_EVENT_REQ";
export const CONFIRM_EVENT_SUCCESS = "CONFIRM_EVENT_SUCCESS";
export const CONFIRM_EVENT_ERROR = "CONFIRM_EVENT_ERROR";

export const SOCIAL_SIGN_IN_REQ = "SOCIAL_SIGN_IN_REQ";
export const SOCIAL_SIGN_IN_SUCCESS = "SOCIAL_SIGN_IN_SUCCESS";
export const SOCIAL_SIGN_IN_ERROR = "SOCIAL_SIGN_IN_ERROR";

export const SOCIAL_EXTRA_DETAILS_REQ = "SOCIAL_EXTRA_DETAILS_REQ";
export const SOCIAL_EXTRA_DETAILS_SUCCESS = "SOCIAL_EXTRA_DETAILS_SUCCESS";
export const SOCIAL_EXTRA_DETAILS_ERROR = "SOCIAL_EXTRA_DETAILS_ERROR";

export const UPDATE_EVENT_REQ = "UPDATE_EVENT_REQUEST";
export const UPDATE_EVENT_SUCCESS = "UPDATE_EVENT_SUCCESS";
export const UPDATE_EVENT_ERROR = "UPDATE_EVENT_ERROR";

export const UPDATE_EVENT_COVER_IMAGE_REQ = "UPDATE_EVENT_COVER_IMAGE_REQ";
export const UPDATE_EVENT_COVER_IMAGE_SUCCESS =
  "UPDATE_EVENT_COVER_IMAGE_SUCCESS";
export const UPDATE_EVENT_COVER_IMAGE_ERROR = "UPDATE_EVENT_COVER_IMAGE_ERROR";

export const DELETE_EVENT_REQ = "DELETE_EVENT_REQUEST";
export const DELETE_EVENT_SUCCESS = "DELETE_EVENT_SUCCESS";
export const DELETE_EVENT_ERROR = "DELETE_EVENT_ERROR";

export const GET_EVENT_REQ = "GET_EVENT_REQ";
export const GET_EVENT_SUCCESS = "GET_EVENT_SUCCESS";
export const GET_EVENT_ERROR = "GET_EVENT_ERROR";

export const GET_MY_EVENT_REQ = "GET_MY_EVENT_REQ";
export const GET_MY_EVENT_SUCCESS = "GET_MY_EVENT_SUCCESS";
export const GET_MY_EVENT_ERROR = "GET_MY_EVENT_ERROR";

export const GET_EVENT_BY_ID_REQ = "GET_EVENT_BY_ID_REQ";
export const GET_EVENT_BY_ID_SUCCESS = "GET_EVENT_BY_ID_SUCCESS";
export const GET_EVENT_BY_ID_ERROR = "GET_EVENT_BY_ID_ERROR";

export const UPDATE_EVENT_CLASS_REQ = "UPDATE_EVENT_CLASS_REQ";
export const UPDATE_EVENT_CLASS_SUCCESS = "UPDATE_EVENT_CLASS_SUCCESS";
export const UPDATE_EVENT_CLASS_ERROR = "UPDATE_EVENT_CLASS_ERROR";

export const UPDATE_EVENT_QUESTION_REQ = "UPDATE_EVENT_QUESTION_REQ";
export const UPDATE_EVENT_QUESTION_SUCCESS = "UPDATE_EVENT_QUESTION_SUCCESS";
export const UPDATE_EVENT_QUESTION_ERROR = "UPDATE_EVENT_QUESTION_ERROR";

export const UPDATE_DRESSAGE_REQ = "UPDATE_DRESSAGE_REQ";
export const UPDATE_DRESSAGE_SUCCESS = "UPDATE_DRESSAGE_SUCCESS";
export const UPDATE_DRESSAGE_ERROR = "UPDATE_DRESSAGE_ERROR";

export const UPDATE_CROSS_COUNTRY_REQ = "UPDATE_CROSS_COUNTRY_REQ";
export const UPDATE_CROSS_COUNTRY_SUCCESSS = "UPDATE_CROSS_COUNTRY_SUCCESSS";
export const UPDATE_CROSSS_COUNTRY_ERROR = "UPDATE_CROSSS_COUNTRY_ERROR";

export const UPDATE_CROSS_COUNTRY_FENCES_REQ =
  "UPDATE_CROSS_COUNTRY_FENCES_REQ";
export const UPDATE_CROSS_COUNTRY_FENCES_SUCCESS =
  "UPDATE_CROSS_COUNTRY_FENCES_SUCCESS";
export const UPDATE_CROSS_COUNTRY_FENCES_ERROR =
  "UPDATE_CROSS_COUNTRY_FENCES_ERROR";

export const UPDATE_SHOW_JUMPING_REQ = "UPDATE_SHOW_JUMPING_REQ";
export const UPDATE_SHOW_JUMPING_SUCCESS = "UPDATE_SHOW_JUMPING_SUCCESS";
export const UPDATE_SHOW_JUMPING_ERROR = "UPDATE_SHOW_JUMPING_ERROR";

export const CREATE_SHOW_JUMPING_FENCS_REQ = "CREATE_SHOW_JUMPING_FENCS_REQ";
export const CREATE_SHOW_JUMPING_FENCS_SUCCESS =
  "CREATE_SHOW_JUMPING_FENCS_SUCCESS";
export const CREATE_SHOW_JUMPING_FENCS_ERROR =
  "CREATE_SHOW_JUMPING_FENCS_ERROR";

export const UPDATE_SHOW_JUMPING_FENCES_REQ = "UPDATE_SHOW_JUMPING_FENCES_REQ";
export const UPDATE_SHOW_JUMPING_FENCES_SUCCESS =
  "UPDATE_SHOW_JUMPING_FENCES_SUCCESS";
export const UPDATE_SHOW_JUMPING_FENCES_ERROR =
  "UPDATE_SHOW_JUMPING_FENCES_ERROR";

export const UPDATE_PROFILE_REQ = "UPDATE_PROFILE_REQ";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR";

export const GET_COMPLETE_EVENT_REQ = "GET_COMPLETE_EVENT_REQ";
export const GET_COMPLETE_EVENT_SUCCESS = "GET_COMPLETE_EVENT_SUCCESS";
export const GET_COMPLETE_EVENT_ERROR = "GET_COMPLETE_EVENT_ERROR";

export const GET_CLASS_BY_EVENT_REQ = "GET_CLASS_BY_EVENT_REQ";
export const GET_CLASS_BY_EVENT_SUCCESS = "GET_CLASS_BY_EVENT_SUCCESS";
export const GET_CLASS_BY_EVENT_ERROR = "GET_CLASS_BY_EVENT_ERROR";

export const GET_LEADERBOARD_REQ = "GET_LEADERBOARD_REQ";
export const GET_LEADERBOARD_SUCCESS = "GET_LEADERBOARD_SUCCESS";
export const GET_LEADERBOARD_ERROR = "GET_LEADERBOARD_ERROR";

export const DELETE_USER_CLASS_REQ = "DELETE_USER_CLASS_REQ";
export const DELETE_USER_CLASS_SUCCESS = "DELETE_USER_CLASS_SUCCESS";
export const DELETE_USER_CLASS_ERROR = "DELETE_USER_CLASS_ERROR";

export const UPDATE_USER_CLASS_REQ = "UPDATE_USER_CLASS_REQ";
export const UPDATE_USER_CLASS_SUCCESS = "UPDATE_USER_CLASS_SUCCESS";
export const UPDATE_USER_CLASS_ERROR = "UPDATE_USER_CLASS_ERROR";

export const DELETE_ACCOUNT_REQ = "DELETE_ACCOUNT_REQ";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_ERROR = "DELETE_ACCOUNT_ERROR";

export const CREATE_SUBSCRIPTION_REQ = "CREATE_SUBSCRIPTION_REQ";
export const CREATE_SUBSCRIPTION_SUCCESS = "CREATE_SUBSCRIPTION_SUCCESS";
export const CREATE_SUBSCRIPTION_ERROR = "CREATE_SUBSCRIPTION_ERROR";

export const CREATE_LINK_REQ = "CREATE_LINK_REQ";
export const CREATE_LINK_SUCCESS = "CREATE_LINK_SUCCESS";
export const CREATE_LINK_ERROR = "CREATE_LINK_ERROR";

export const CREATE_ACCOUNT_REQ = "CREATE_ACCOUNT_REQ";
export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_ERROR = "CREATE_ACCOUNT_ERROR";

export const CHECK_ACCOUNT_REQ = "CHECK_ACCOUNT_REQ";
export const CHECK_ACCOUNT_SUCCESS = "CHECK_ACCOUNT_SUCCESS";
export const CHECK_ACCOUNT_ERROR = "CHECK_ACCOUNT_ERROR";

export const CHANGE_PASSWORD_REQ = "CHANGE_PASSWORD_REQ";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";

export const DASHBOARD_COUNT_REQ = "DASHBOARD_COUNT_REQ";
export const DASHBOARD_COUNT_SUCCESS = "DASHBOARD_COUNT_SUCCESS";
export const DASHBOARD_COUNT_ERROR = "DASHBOARD_COUNT_ERROR";

export const GET_NOTIFICATION_REQ = "GET_NOTIFICATION_REQ";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_ERROR = "GET_NOTIFICATION_ERROR";

export const GET_ORDER_REQ = "GET_ORDER_REQ";
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS";
export const GET_ORDER_ERROR = "GET_ORDER_ERROR";

export const GET_USER_REQ = "GET_USER_REQ";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";

export const CREATE_USER_REQ = "CREATE_USER_REQ";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";

export const GET_ALLCUSTOMER_REQ = "GET_ALLCUSTOMER_REQ";
export const GET_ALLCUSTOMER_SUCCESS = "GET_ALLCUSTOMER_SUCCESS";
export const GET_ALLCUSTOMER_ERROR = "GET_ALLCUSTOMER_ERROR";

export const ALLOW_CUSTOMER_REQ = "ALLOW_CUSTOMER_REQ";
export const ALLOW_CUSTOMER_SUCCESS = "ALLOW_CUSTOMER_SUCCESS";
export const ALLOW_CUSTOMER_ERROR = "ALLOW_CUSTOMER_ERROR";

export const RESTRICT_CUSTOMER_REQ = "RESTRICT_CUSTOMER_REQ";
export const RESTRICT_CUSTOMER_SUCCESS = "RESTRICT_CUSTOMER_SUCCESS";
export const RESTRICT_CUSTOMER_ERROR = "RESTRICT_CUSTOMER_ERROR";

// export const GET_ALLCUSTOMER_REQ = "GET_ALLCUSTOMER_REQ";
// export const GET_ALLCUSTOMER_SUCCESS = "GET_ALLCUSTOMER_SUCCESS";
// export const GET_ALLCUSTOMER_ERROR = "GET_ALLCUSTOMER_ERROR";

export const GET_CATEGORIES_REQ = "GGET_CATEGORIES_REQ";
export const GET_CATEGORIES_SUCCESS = "GGET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_ERROR = "GGET_CATEGORIES_ERROR";

export const GET_PRODUCT_REQ = "GET_PRODUCT_REQ";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR";

export const GET_SHIPPINGCOST_REQ = "GET_SHIPPINGCOST_REQ";
export const GET_SHIPPINGCOST_SUCCESS = "GET_SHIPPINGCOST_SUCCESS";
export const GET_SHIPPINGCOST_ERROR = "GET_SHIPPINGCOST_ERROR";

export const UPDATE_SHIPPINGCOST_REQ = "UPDATE_SHIPPINGCOST_REQ";
export const UPDATE_SHIPPINGCOST_SUCCESS = "UPDATE_SHIPPINGCOST_SUCCESS";
export const UPDATE_SHIPPINGCOST_ERROR = "UPDATE_SHIPPINGCOST_ERROR";

export const POST_SHIPPINGCOST_REQ = "POST_SHIPPINGCOST_REQ";
export const POST_SHIPPINGCOST_SUCCESS = "POST_SHIPPINGCOST_SUCCESS";
export const POST_SHIPPINGCOST_ERROR = "POST_SHIPPINGCOST_ERROR";

export const GET_USER_DETAIL_REQ = "GET_USER_DETAIL_REQ";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_ERROR = "GET_USER_DETAIL_ERROR";

export const GET_COMPANY_DETAIL_REQ = "GET_COMPANY_DETAIL_REQ";
export const GET_COMPANY_DETAIL_SUCCESS = "GET_COMPANY_DETAIL_SUCCESS";
export const GET_COMPANY_DETAIL_ERROR = "GET_COMPANY_DETAIL_ERROR";

export const GET_LOCATION_REQ = "GET_LOCATION_REQ";
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS";
export const GET_LOCATION_ERROR = "GET_LOCATION_ERROR";

export const GET_CARD_REQ = "GET_CARD_REQ";
export const GET_CARD_SUCCESS = "GET_CARD_SUCCESS";
export const GET_CARD_ERROR = "GET_CARD_ERROR";

export const CREATE_LOCATION_REQ = "CREATE_LOCATION_REQ";
export const CREATE_LOCATION_SUCCESS = "CREATE_LOCATION_SUCCESS";
export const CREATE_LOCATION_ERROR = "CREATE_LOCATION_ERROR";

export const DELETE_LOCATION_REQ = "DELETE_LOCATION_REQ";
export const DELETE_LOCATION_SUCCESS = "DELETE_LOCATION_SUCCESS";
export const DELETE_LOCATION_ERROR = "DELETE_LOCATION_ERROR";

export const UPDATE_LOCATION_REQ = "UPDATE_LOCATION_REQ";
export const UPDATE_LOCATION_SUCCESS = "UPDATE_LOCATION_SUCCESS";
export const UPDATE_LOCATION_ERROR = "UPDATE_LOCATION_ERROR";

export const UPDATE_ASSETS_REQ = "UPDATE_ASSETS_REQ";
export const UPDATE_ASSETS_SUCCESS = "UPDATE_ASSETS_SUCCESS";
export const UPDATE_ASSETS_ERROR = "UPDATE_ASSETS_ERROR";

export const UPDATE_BUSINESS_INFO_REQ = "UPDATE_BUSINESS_INFO_REQ";
export const UPDATE_BUSINESS_INFO_SUCCESS = "UPDATE_BUSINESS_INFO_SUCCESS";
export const UPDATE_BUSINESS_INFO_ERROR = "UPDATE_BUSINESS_INFO_ERROR";

export const UPDATE_PROFILE_INFO_REQ = "UPDATE_PROFILE_INFO_REQ";
export const UPDATE_PROFILE_INFO_SUCCESS = "UPDATE_PROFILE_INFO_SUCCESS";
export const UPDATE_PROFILE_INFO_ERROR = "UPDATE_PROFILE_INFO_ERROR";

export const UPDATE_PRODUCT_REQ = "UPDATE_PRODUCT_REQ";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR";

export const GET_ORDER_BY_ID_REQ = "GET_ORDER_BY_ID_REQ";
export const GET_ORDER_BY_ID_SUCCESS = "GET_ORDER_BY_ID_SUCCESS";
export const GET_ORDER_BY_ID_ERROR = "GET_ORDER_BY_ID_ERROR";

export const ORDER_APPROVAL_REQ = "ORDER_APPROVAL_REQ";
export const ORDER_APPROVAL_SUCCESS = "ORDER_APPROVAL_SUCCESS";
export const ORDER_APPROVAL_ERROR = "ORDER_APPROVAL_ERROR";
export const POST_PRODUCT_REQ = "POST_PRODUCT_REQ";
export const POST_PRODUCT_SUCCESS = "POST_PRODUCT_SUCCESS";
export const POST_PRODUCT_ERROR = "POST_PRODUCT_ERROR";

export const POST_CUSTOMPRODUCT_REQ = "POST_CUSTOMPRODUCT_REQ";
export const POST_CUSTOMPRODUCT_SUCCESS = "POST_CUSTOMPRODUCT_SUCCESS";
export const POST_CUSTOMPRODUCT_ERROR = "POST_CUSTOMPRODUCT_ERROR";

export const GET_BASEMIX_CATEGORIES_REQ = "GET_BASEMIX_CATEGORIES_REQ";
export const GET_BASEMIX_CATEGORIES_SUCCESS = "GET_BASEMIX_CATEGORIES_SUCCESS";
export const GET_BASEMIX_CATEGORIES_ERROR = "GET_BASEMIX_CATEGORIES_ERROR";

export const GET_BASEMIXES_REQ = "GET_BASEMIXES_REQ";
export const GET_BASEMIXES_SUCCESS = "GET_BASEMIXES_SUCCESS";
export const GET_BASEMIXES_ERROR = "GET_BASEMIX_CATEGORIES_ERROR";

export const GET_ADDITIVES_REQ = "GET_ADDITIVES_REQ";
export const GET_ADDITIVES_SUCCESS = "GET_ADDITIVES_SUCCESS";
export const GET_ADDITIVES_ERROR = "GET_ADDITIVES_ERROR";

export const GET_BASEMIXES_CATEGORIES_REQ = "GET_BASEMIXES_CATEGORIES_REQ";
export const GET_BASEMIXES_CATEGORIES_SUCCESS = "GET_BASEMIXES_CATEGORIES_SUCCESS";
export const GET_BASEMIXES_CATEGORIES_ERROR = "GET_BASEMIXES_CATEGORIES_ERROR";

export const POST_BASEMIX_REQ = "POST_BASEMIX_REQ";
export const POST_BASEMIX_SUCCESS = "POST_BASEMIX_SUCCESS";
export const POST_BASEMIX_ERROR = "POST_BASEMIX_ERROR";

export const DELETE_DOC_REQ = "DELETE_DOC_REQ";
export const DELETE_DOC_SUCCESS = "DELETE_DOC_SUCCESS";
export const DELETE_DOC_ERROR = "DELETE_DOC_ERROR";

export const UPLOAD_DOC_REQ = "UPLOAD_DOC_REQ";
export const UPLOAD_DOC_SUCCESS = "UPLOAD_DOC_SUCCESS";
export const UPLOAD_DOC_ERROR = "UPLOAD_DOC_ERROR";

export const IS_READ_REQ = "IS_READ_REQ";
export const IS_READ_SUCCESS = "IS_READ_SUCCESS";
export const IS_READ_ERROR = "IS_READ_ERROR";

export const GET_LOGISTICS_REQ = "GET_LOGISTICS_REQ";
export const GET_LOGISTICS_SUCCESS = "GET_LOGISTICS_SUCCESS";
export const GET_LOGISTICS_ERROR = "GET_LOGISTICS_ERROR";

export const GET_LOG_PARTNER_REQ = "GET_LOG_PARTNER_REQ";
export const GET_LOG_PARTNER_SUCCESS = "GET_LOG_PARTNER_SUCCESS";
export const GET_LOG_PARTNER_ERROR = "GET_LOG_PARTNER_ERROR";

export const MARK_AS_FAV_REQ = "MARK_AS_FAV_REQ";
export const MARK_AS_FAV_SUCCESS = "MARK_AS_FAV_SUCCESS";
export const MARK_AS_FAV_ERROR = "MARK_AS_FAV_REQ";

export const VALIDATION_REQ = "VALIDATION_REQ";
export const VALIDATION_SUCCESS = "VALIDATION_SUCCESS";
export const VALIDATION_ERROR = "VALIDATION_ERROR";

export const GET_TEMPLATE_REQ = "GET_TEMPLATE_REQ";
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS";
export const GET_TEMPLATE_ERROR = "GET_TEMPLATE_ERROR";

export const POST_FILE_REQ = "POST_FILE_REQ";
export const POST_FILE_SUCCESS = "POST_FILE_SUCCESS";
export const POST_FILE_ERROR = "POST_FILE_ERROR";

export const CREATE_ASSETS_REQ = "CREATE_ASSETS_REQ";
export const CREATE_ASSETS_SUCCESS = "CREATE_ASSETS_SUCCESS";
export const CREATE_ASSETS_ERROR = "CREATE_ASSETS_ERROR";

export const DELETE_CARD_REQ = "DELETE_CARD_REQ";
export const DELETE_CARD_SUCCESS = "DELETE_CARD_SUCCESS";
export const DELETE_CARD_ERROR = "DELETE_CARD_ERROR";

export const SET_CARD_DEFAULT_REQ = "SET_CARD_DEFAULT_REQ";
export const SET_CARD_DEFAULT_SUCCESS = "SET_CARD_DEFAULT_SUCCESS";
export const SET_CARD_DEFAULT_ERROR = "SET_CARD_DEFAULT_ERROR";

export const GET_STORE_URL_REQ = "GET_STORE_URL_REQ";
export const GET_STORE_URL_SUCCESS = "GET_STORE_URL_SUCCESS";
export const GET_STORE_URL_ERROR = "GET_STORE_URL_ERROR";

export const VERIFY_ZIP_CODE_REQ = "VERIFY_ZIP_CODE_REQ";
export const VERIFY_ZIP_CODE_SUCCESS = "VERIFY_ZIP_CODE_SUCCESS";
export const VERIFY_ZIP_CODE_ERROR = "VERIFY_ZIP_CODE_ERROR";

export const CREATE_TOKEN_REQ = "CREATE_TOKEN_REQ";
export const CREATE_TOKEN_SUCCESS = "CREATE_TOKEN_SUCCESS";
export const CREATE_TOKEN_ERROR = "CREATE_TOKEN_ERROR";

export const CREATE_CARD_REQ = "CREATE_CARD_REQ";
export const CREATE_CARD_SUCCESS = "CREATE_CARD_SUCCESS";
export const CREATE_CARD_ERROR = "CREATE_CARD_ERROR";

export const GET_SUBSCRIPTION_PLAN_REQ = "GET_SUBSCRIPTION_PLAN_REQ";
export const GET_SUBSCRIPTION_PLAN_SUCCESS = "GET_SUBSCRIPTION_PLAN_SUCCESS";
export const GET_SUBSCRIPTION_PLAN_ERROR = "GET_SUBSCRIPTION_PLAN_ERROR";

export const DOWNLOAD_RECIPT_REQ = "DOWNLOAD_RECIPT_REQ";
export const DOWNLOAD_RECIPT_SUCCESS = "DOWNLOAD_RECIPT_SUCCESS";
export const DOWNLOAD_RECIPT_ERROR = "DOWNLOAD_RECIPT_ERROR";

export const SHARE_RECIPT_REQ = "SHARE_RECIPT_REQ";
export const SHARE_RECIPT_SUCCESS = "SHARE_RECIPT_SUCCESS";
export const SHARE_RECIPT_ERROR = "SHARE_RECIPT_ERROR";

export const DELETE_LOGISTICS_PARTNER_REQ = 'DELETE_LOGISTICS_PARTNER_REQ'
export const DELETE_LOGISTICS_PARTNER_SUCCESS = 'DELETE_LOGISTICS_PARTNER_SUCCESS'
export const DELETE_LOGISTICS_PARTNER_ERROR = 'DELETE_LOGISTICS_PARTNER_ERROR'

export const USER_AUTHENTICATION_REQ = 'USER_AUTHENTICATION_REQ'
export const USER_AUTHENTICATION_SUCCESS = 'USER_AUTHENTICATION_SUCCESS'
export const USER_AUTHENTICATION_ERROR = 'DELETE_LOGISTICS_PARTNER_ERROR'


export const CONNECT_STRIPE_REQ = 'CONNECT_STRIPE_REQ'
export const CONNECT_STRIPE_SUCCESS = 'CONNECT_STRIPE_SUCCESS'
export const CONNECT_STRIPE_ERROR = 'CONNECT_STRIPE_ERROR'


export const CREATE_REACTIVATION_SUBSCRIPTION_REQ = "CREATE_REACTIVATION_SUBSCRIPTION_REQ";
export const CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS = "CREATE_REACTIVATION_SUBSCRIPTION_SUCCESS";
export const CREATE_REACTIVATION_SUBSCRIPTION_ERROR = "CREATE_REACTIVATION_SUBSCRIPTION_ERROR";

export const CREATE_CANCELLATION_SUBSCRIPTION_REQ = "CREATE_CANCELLATION_SUBSCRIPTION_REQ";
export const CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS = "CREATE_CANCELLATION_SUBSCRIPTION_SUCCESS";
export const CREATE_CANCELLATION_SUBSCRIPTION_ERROR = "CREATE_CANCELLATION_SUBSCRIPTION_ERROR";


export const PLANT_TAB_PRODUCT_KEY_REQ = "PLANT_TAB_PRODUCT_KEY_REQ";
export const PLANT_TAB_PRODUCT_KEY_SUCCESS = "PLANT_TAB_PRODUCT_KEY_SUCCESS";
export const PLANT_TAB_PRODUCT_KEY_ERROR = "PLANT_TAB_PRODUCT_KEY_ERROR ";


